export enum RoutesEnum {
  Tournaments = 'turnieje',
  Ranking = 'ranking',
  Home = '',
  Login = 'login',
  Register = 'rejestracja',
  ProfileComplete = 'uzupelnij-profil',
  ProfileReady = 'profil-uzupelniony',
  Licence = 'licencja',
  ThankYou = 'dziekujemy',
  Players = 'zawodnicy',
  PlayerResults = 'wyniki',
  PlayerScheduledMatches = 'zaplanowane-mecze',
  PlayerWideos = 'mecze-w-tv',
  MyAccount = 'moje-konto',
  MyProfile = 'moj-profil',
  EditProfile = 'edytuj-profil',
  ChangePassword = 'zmiana-hasla',
  RemindPassword = 'przypomnij-haslo',
  ResetPassword = 'zmien-haslo',
  List = 'lista',
  Start = 'start',
  Verify = 'weryfikacja',
  Congratulations = 'gratulacje',
}

export enum RoutesParamsEnum {
  clubSlug = 'clubSlug',
  tournamentSlug = 'tournamentSlug',
  tournamentDate = 'tournamentDate',
}

export enum RoutesTournamentEnum {
  Information = 'informacje',
  Members = 'uczestnicy',
  Results = 'wyniki',
  Table = 'tabela',
  CupPhase = 'faza-pucharowa',
  Transmission = 'transmisja',
  TakePart = 'wez-udzial',
  YouAreRegistered = 'jestes-zapisany',
}

export enum RoutesRankingEnum {
  General = 'ogolny',
  Men = 'mezczyni',
  Women = 'kobiety',
}
